import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Church, Heart, Cross, Star } from 'lucide-react';

export const Footer = () => {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Top Section */}
        <div className="flex flex-col items-center text-center mb-8">
          {/* Logo */}
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center">
              <Church className="w-5 h-5 text-primary-foreground" />
            </div>
            <span className="font-heading text-xl font-semibold text-foreground">
              {language === 'fr' ? 'Mon Saint Patron' : 'My Patron Saint'}
            </span>
          </div>

          {/* Description */}
          <p className="text-sm text-muted-foreground max-w-md">
            {t('footer.description')}
          </p>
        </div>

        {/* Divider */}
        <div className="flex items-center justify-center gap-4 my-8">
          <div className="h-px flex-1 max-w-[100px] bg-gradient-to-r from-transparent to-border" />
          <Cross className="w-4 h-4 text-gold/50" />
          <div className="h-px flex-1 max-w-[100px] bg-gradient-to-l from-transparent to-border" />
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>
            © {currentYear} {language === 'fr' ? 'Mon Saint Patron' : 'My Patron Saint'}. {t('footer.rights')}.
          </p>
          <p className="flex items-center gap-1">
            {t('footer.madeWith')} <Heart className="w-4 h-4 text-accent fill-accent" /> & {t('footer.faith')}
          </p>
        </div>

        {/* Decorative Stars */}
        <div className="flex justify-center mt-8">
          <div className="flex items-center gap-2 opacity-30">
            <Star className="w-3 h-3 text-gold" />
            <Star className="w-3 h-3 text-gold" />
            <Star className="w-4 h-4 text-gold" />
            <Star className="w-3 h-3 text-gold" />
            <Star className="w-3 h-3 text-gold" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
